var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_77681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4719 2.73634L16.6344 2.43632L16.3344 0.673828L16.0719 2.47383L14.3469 2.73634L16.0719 2.99882L16.3344 4.79882L16.6344 3.03633L18.4719 2.73634ZM3.62185 0.673828L3.54686 1.38634L2.79688 1.49884L3.50935 1.61134L3.62185 2.32382L3.77186 1.61134L4.48438 1.49884L3.73435 1.38634L3.62185 0.673828Z",
    fill: "#FFB803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61248 2.96446L2.42499 1.68945L2.2375 2.96446L1 3.15195L2.2375 3.37695L2.42499 4.65196L2.61248 3.37695L3.925 3.15195L2.61248 2.96446Z",
    fill: "#FFB803"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3219 8.25041L10.0344 3.90039H9.0969L6.54688 8.25041H12.3219Z",
    fill: "#84DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2438 3.90039H10.0312L12.3188 8.25041L15.2438 3.90039Z",
    fill: "#00B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4031 8.25041L15.2906 3.90039H15.2531L12.3281 8.25041H18.4031Z",
    fill: "#84DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47187 18.6769L12.3219 8.25195H6.54688L9.47187 18.6769Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09531 3.90039H3.69531L6.54529 8.25041L9.09531 3.90039Z",
    fill: "#00B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.69687 3.90039H3.65936L0.546875 8.25041H6.54685L3.69687 3.90039Z",
    fill: "#84DBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3969 8.25195L9.47185 18.6769L0.546875 8.25195H6.54685L9.47185 18.6769L12.3219 8.25195H18.3969Z",
    fill: "#00B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.325 7.08321L12.175 8.0582L11.1625 8.20821L12.175 8.35823L12.325 9.4082L12.475 8.35823L13.4875 8.20821L12.475 8.0582L12.325 7.08321ZM4.97498 4.9082L4.825 5.88323L3.8125 6.0332L4.78749 6.18322L4.97498 7.23323L5.12499 6.22073L6.13749 6.0332L5.12499 5.88323L4.97498 4.9082Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_77681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5 0.673828)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.22b3a94394f850259b73448602a343b7.svg";
export { ForwardRef as ReactComponent };